import { useQuery } from "@tanstack/react-query";
import { Tags } from "@src/api/v1/Tags";
import { OpenUpHttpClient } from "@src/api/OpenUpHttpClient";
import { queryIdentifiers } from "@src/utils/constants";
import { sessionTypeTagName } from "./tags";

/**
 * Hook to get session types available for a specific client
 */
export const useClientAvailableSessionTypesQuery = (clientId: string) => {
  return useQuery({
    queryKey: [queryIdentifiers.tags, sessionTypeTagName, "client", clientId],
    queryFn: () =>
      new Tags(OpenUpHttpClient).getTagsAvailableForClient({
        tagType: sessionTypeTagName,
        availableForUserId: clientId,
      }),
    enabled: !!clientId,
    staleTime: 1 * 60 * 1000, // 1 minute
  });
};
